export const CAKE_BNB_LP_MAINNET = '0x1090dC3507131aED20081be2c002A2F1203d9d4a'
